import { useMemo } from "react";
import { useGeneralPermissions, Result as GeneralResult } from "app/api/graph/hook/use-general-permissions";
import { ReportVersionAttribute } from "app/api/graph/security-attributes";

type Result = GeneralResult & {
    canViewReadReceipts: boolean;
    canTransition: boolean;
    canCreateDeliverableFile: boolean;
    canCreateTestTypePrerequisite: boolean;
    canSendCustomEmail: boolean;
    canSendDailyTestEmail: boolean;
    canSendRequestInformationEmail: boolean;
};

export const useReportVersionPermissions = (permissions: string[] | null | undefined): Result => {
    const generalResult = useGeneralPermissions(permissions);

    return useMemo(
        () => ({
            ...generalResult,
            canViewReadReceipts: permissions?.includes(ReportVersionAttribute.ViewReadReceipts) ?? false,
            canTransition: permissions?.includes(ReportVersionAttribute.Transition) ?? false,
            canCreateDeliverableFile: permissions?.includes(ReportVersionAttribute.CreateDeliverableFile) ?? false,
            canCreateTestTypePrerequisite:
                permissions?.includes(ReportVersionAttribute.CreateTestTypePrerequisite) ?? false,
            canSendCustomEmail: permissions?.includes(ReportVersionAttribute.SendCustomEmail) ?? false,
            canSendDailyTestEmail: permissions?.includes(ReportVersionAttribute.SendDailyTestEmail) ?? false,
            canSendRequestInformationEmail:
                permissions?.includes(ReportVersionAttribute.SendRequestInformationEmail) ?? false,
        }),
        [permissions],
    );
};
